/**
 * This file is for 'special publications'.
 *
 * This is for publications that we have a relationship, and need to handle things a bit differently.
 *
 * For example, Linea wants custom legal text on their subscribe form.
 *
 */

const LINEA_BLOG_ID = "VLmIi8vcq5k3GIjkaP7c"

/**
 * Helper function that is used to determine if we should always show an email form,
 * for a 'special' publication.
 *
 */
export function alwaysShowEmailForm(blogId: string): boolean {
  return blogId === LINEA_BLOG_ID
}

/**
 * Footer text that some special publications want to show.
 *
 */
export function SpecialSubscribeFooterText({ blogId }: { blogId?: string }) {
  if (!blogId) return null

  /**
   * Linea requested special legal text for their subscribe form.
   */
  if (blogId === LINEA_BLOG_ID) {
    return (
      <p className="text-xs pt-4 text-gray-500">
        Linea may use the information provided to contact you about their
        products and services. By clicking “Subscribe” you consent to receive
        such communications from Linea. You may unsubscribe from these
        communications at any time by following the unsubscribe instructions
        contained in these communications. For information on Linea's privacy
        practices and their commitment to protecting your privacy, please review
        Linea's{" "}
        <a
          href="https://linea.build/privacy-policy"
          className="text-primary"
          target="_blank"
        >
          Privacy Policy.
        </a>
      </p>
    )
  }

  return null
}
